"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfiguratorContext = exports.ConfiguratorProvider = void 0;
const react_1 = __importStar(require("react"));
const ConfiguratorContext = (0, react_1.createContext)({});
const ConfiguratorProvider = ({ children }) => {
    var _a;
    const listeners = (0, react_1.useRef)(new Map());
    const [iframeRef, setIframeRef] = (0, react_1.useState)();
    const [incomingItem, setIncomingItem] = (0, react_1.useState)();
    const [history, setHistory] = (0, react_1.useState)({ canUndo: false, canRedo: false });
    const origin = (_a = (0, react_1.useMemo)(() => (iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.src) && new URL(iframeRef.src).origin, [iframeRef === null || iframeRef === void 0 ? void 0 : iframeRef.src])) !== null && _a !== void 0 ? _a : '*';
    const postMessage = (0, react_1.useCallback)((event, data) => {
        var _a;
        if (!iframeRef)
            return console.error('No Configurator iframe in scope');
        (_a = iframeRef.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({ event, data }, origin);
    }, [iframeRef]);
    const handleDragOver = (x, y) => {
        if (!incomingItem)
            return;
        postMessage('incoming-item', { x, y, drag: true, item: incomingItem === null || incomingItem === void 0 ? void 0 : incomingItem.item, props: incomingItem === null || incomingItem === void 0 ? void 0 : incomingItem.props });
    };
    const handleDrop = (x, y) => {
        if (!incomingItem)
            return;
        postMessage('incoming-item', { x, y, drop: true, item: incomingItem === null || incomingItem === void 0 ? void 0 : incomingItem.item, props: incomingItem === null || incomingItem === void 0 ? void 0 : incomingItem.props });
        setIncomingItem(undefined);
    };
    const addEventListener = (0, react_1.useCallback)((event, listener, once) => {
        var _a;
        const existingListeners = (_a = listeners.current.get(event)) !== null && _a !== void 0 ? _a : [];
        listeners.current.set(event, [...existingListeners, { listener, once: once === 'once' }]);
    }, []);
    const removeEventListener = (0, react_1.useCallback)((event, listener) => {
        var _a;
        const existingListeners = (_a = listeners.current.get(event)) !== null && _a !== void 0 ? _a : [];
        listeners.current.set(event, existingListeners.filter(x => x.listener !== listener));
    }, []);
    (0, react_1.useEffect)(() => {
        if (!iframeRef)
            return;
        const onMessage = (message) => {
            var _a;
            if (message.origin !== origin)
                return;
            const { event, data } = message.data;
            const activeListeners = (_a = listeners.current.get(event)) !== null && _a !== void 0 ? _a : [];
            activeListeners.forEach(({ listener, once }) => {
                if (once)
                    removeEventListener(event, listener);
                listener(data);
            });
        };
        window.addEventListener('message', onMessage);
        return () => window.removeEventListener('message', onMessage);
    }, [iframeRef]);
    (0, react_1.useEffect)(() => {
        if (!iframeRef)
            return;
        const onTouchMove = (e) => {
            var _a;
            if (!incomingItem)
                return;
            const point = [((_a = e.touches[0]) !== null && _a !== void 0 ? _a : e.changedTouches[0])].map(({ clientX, clientY }) => ({ x: clientX, y: clientY }))[0];
            const { x, y, left, right, bottom, top } = iframeRef.getClientRects()[0];
            const isAboveCanvas = point.x > left && point.x < right && point.y < bottom && point.y > top;
            if (isAboveCanvas)
                handleDragOver(point.x - x, point.y - y);
        };
        const onTouchEnd = (e) => {
            var _a;
            if (!incomingItem)
                return;
            const point = [((_a = e.touches[0]) !== null && _a !== void 0 ? _a : e.changedTouches[0])].map(({ clientX, clientY }) => ({ x: clientX, y: clientY }))[0];
            const { x, y, left, right, bottom, top } = iframeRef.getClientRects()[0];
            const isAboveCanvas = point.x > left && point.x < right && point.y < bottom && point.y > top;
            if (isAboveCanvas && incomingItem)
                handleDrop(point.x - x, point.y - y);
            setIncomingItem(undefined);
        };
        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('touchend', onTouchEnd);
        return () => {
            document.removeEventListener('touchmove', onTouchMove);
            document.addEventListener('touchend', onTouchEnd);
        };
    }, [iframeRef, incomingItem]);
    (0, react_1.useEffect)(() => {
        const onHistoryUpdated = (history) => setHistory(history);
        addEventListener('history-updated', onHistoryUpdated);
        return () => removeEventListener('history-updated', onHistoryUpdated);
    }, [iframeRef]);
    const cameraToSelected = (0, react_1.useCallback)(() => postMessage('camera-to-selected'), [postMessage]);
    const cameraToPrevious = (0, react_1.useCallback)(() => postMessage('camera-to-previous'), [postMessage]);
    const context = (0, react_1.useMemo)(() => ({
        setIframeRef: (ref) => setIframeRef(ref),
        cameraRotateLeft: () => postMessage('camera-rotate-left'),
        cameraRotateRight: () => postMessage('camera-rotate-right'),
        cameraZoomIn: () => postMessage('camera-zoom-in'),
        cameraZoomOut: () => postMessage('camera-zoom-out'),
        setCameraZoom: (value) => postMessage('set-camera-zoom', { value }),
        setCameraView: (value) => postMessage('set-camera-view', { value }),
        cameraToSelected,
        cameraToPrevious,
        toggleAnnotations: (value) => postMessage('toggle-annotations', { value }),
        setVisibility: (settings) => Object.entries(settings).forEach(([item, value]) => postMessage('set-visibility', { item, value })),
        clearSelection: () => postMessage('clear-selection'),
        loadProject: async (config) => new Promise((resolve, reject) => {
            addEventListener('loaded-project-ready', resolve, 'once');
            addEventListener('loaded-project-failed', reject, 'once');
            postMessage('load-project', config);
        }),
        saveProject: async () => new Promise((resolve, _) => {
            addEventListener('savefile-ready', resolve, 'once');
            postMessage('save-project');
        }),
        removeSelectedItem: () => new Promise((resolve, _) => {
            addEventListener('item-selected-internal', resolve, 'once');
            postMessage('remove-selected-item');
        }),
        incomingItem,
        setIncomingItem: (item, props) => setIncomingItem(item ? { item, props: props !== null && props !== void 0 ? props : {} } : undefined),
        handleDragOver: (x, y) => handleDragOver(x, y),
        handleDrop: (x, y) => handleDrop(x, y),
        updateItem: (item, id, props, args) => postMessage('update-item', { item, id, props, args }),
        updateItems: (items, args) => postMessage('update-items', { items, args }),
        replaceItem: (oldItem, oldItemId, newItem, newItemProps) => new Promise((resolve, _) => {
            addEventListener('item-selected-internal', resolve, 'once');
            postMessage('replace-item', {
                oldItem: { item: oldItem, id: oldItemId },
                newItem: { item: newItem, props: newItemProps },
            });
        }),
        requestImage: async (args) => new Promise((resolve, _) => {
            addEventListener('image-result', resolve, 'once');
            postMessage('request-image', args);
        }),
        redo: history.canRedo ? (() => postMessage('redo')) : undefined,
        undo: history.canUndo ? (() => postMessage('undo')) : undefined,
        setMode: (value) => postMessage('set-mode', { value }),
        selectItem: (id) => new Promise((resolve, _) => {
            addEventListener('item-selected', resolve, 'once');
            postMessage('select-item', { id });
        }),
        postMessage: (event, data) => postMessage(event, data),
        addEventListener: (event, listener) => addEventListener(event, listener),
        removeEventListener: (event, listener) => removeEventListener(event, listener),
    }), [iframeRef, incomingItem, history]);
    return (react_1.default.createElement(ConfiguratorContext.Provider, { value: context }, children));
};
exports.ConfiguratorProvider = ConfiguratorProvider;
const useConfiguratorContext = () => (0, react_1.useContext)(ConfiguratorContext);
exports.useConfiguratorContext = useConfiguratorContext;
